// Modules
import React, { Fragment, ReactElement, useState } from "react";
import { useSelector } from "react-redux";

// Styled Components
import * as EVENT from "./event-card-lg.styles";
import * as TYPO from "../../styles/common/typo.styles";
import { MarginTop } from "../../styles/common/space.styles";

// Constants
import { constant } from "../../constants/contant";

// Types
import { Event } from "../../types/events";

// Assets
import LeftArrow from "../../assets/left-arrow.svg";

import { capitalizedLang } from "../../selectors/common.selector";
import DateMonth from "../event/event.dateMonth.component";

const EventCardLg = ({
  event,
  enableDate = true,
  enableArrow = true,
  enableType = true,
  enableColorInvert = true,
}: {
  event: Event;
  enableDate: Boolean;
  enableArrow: Boolean;
  enableType: Boolean;
  enableColorInvert: Boolean;
}): ReactElement => {
  // Dispatcher
  const dir = useSelector((state: any) => state.common.dir);
  const lang = useSelector((state: any) => capitalizedLang()(state));
  // State
  const [hover, setHover] = useState(false);
  // Render
  if (event)
    return (
      <EVENT.Card
        onMouseLeave={() => setHover(false)}
        onMouseOver={() => setHover(true)}
      >
        <DateMonth event={event}/>
        <EVENT.Highlighter>
          {event.isOnlineEvent && (
            <TYPO.BodyBoldSm>
              {constant[lang].VARIABLES.ONLINE_EVENT}
            </TYPO.BodyBoldSm>
          )}
          {event.isPhysicalEvent && (
            <TYPO.BodyBoldSm>
              {constant[lang].VARIABLES.PHYSICAL_EVENT}
            </TYPO.BodyBoldSm>
          )}
          {event.isCombinedEvent && (
            <TYPO.BodyBoldSm>
              {constant[lang].VARIABLES.COMBINED_EVENT}
            </TYPO.BodyBoldSm>
          )}
        </EVENT.Highlighter>

        <EVENT.Details enableColorInvert={enableColorInvert}>
          <EVENT.PBold>{event.type}</EVENT.PBold>
          <MarginTop size={6} />
          <EVENT.H1 enableColorInvert={enableColorInvert}>
            {event.title}
          </EVENT.H1>
          <MarginTop size={10} />
          <EVENT.P enableColorInvert={enableColorInvert}>
            {event.subTitle}
          </EVENT.P>
          <MarginTop size={20} />
          {enableDate && (
            <>
              <EVENT.P enableColorInvert={enableColorInvert}>
                {event.fullDate}
              </EVENT.P>
              <MarginTop size={4} />
              <EVENT.P enableColorInvert={enableColorInvert}>
                {event.hebrewDate}
              </EVENT.P>
              <MarginTop size={4} />
              <EVENT.P enableColorInvert={enableColorInvert}>
                {event.time}
              </EVENT.P>
              <MarginTop size={16} />
            </>
          )}
          {enableType && (
            <EVENT.TypeView>
              <EVENT.PBoldXs> {event.cost}</EVENT.PBoldXs>
              {event.inviteType && (
                <>
                  <EVENT.TextDivider>|</EVENT.TextDivider>
                  <EVENT.PBoldXs> {event.inviteType}</EVENT.PBoldXs>
                </>
              )}
            </EVENT.TypeView>
          )}
          {enableArrow && (
            <EVENT.LeftArrow direction={dir} hover={hover} src={LeftArrow} alt="Left Arrow"/>
          )}{" "}
        </EVENT.Details>
        <EVENT.Banner src={event.bannerUrl}  alt="Banner"/>
      </EVENT.Card>
    );

  return <Fragment />;
};

export default EventCardLg;
